import React, { useState } from "react";
import Table from "../../core/common/dataTable/index";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { manageusersData } from "../../core/data/json/manageuser";
import CollapseHeader from "../../core/common/collapse-header";
import { label } from "yet-another-react-lightbox/*";

const Manageusers = () => {
  const data = manageusersData;

  const options2 = [
    { value: "Choose", label: "Choose" },
    { value: "Germany", label: "Germany" },
    { value: "USA", label: "USA" },
    { value: "Canada", label: "Canada" },
    { value: "India", label: "India" },
    { value: "China", label: "China" },
  ];
  const options3 = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];
  const [passwords, setPasswords] = useState([false, false]);

  const togglePassword = (index: any) => {
    const updatedPasswords = [...passwords];
    updatedPasswords[index] = !updatedPasswords[index];
    setPasswords(updatedPasswords);
  };
  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const initializeStarsState = () => {
    const starsState: { [key: number]: boolean } = {};
    manageusersData.forEach((item, index) => {
      starsState[index] = false;
    });
    setStars(starsState);
  };

  React.useEffect(() => {
    initializeStarsState();
  }, []);
  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const columns = [
    {
      title: "",
      dataIndex: "",
      render: (text: string, record: any, index: number) => (
        <div
          className={`set-star rating-select ${stars[index] ? "filled" : ""}`}
          onClick={() => handleStarToggle(index)}
        >
          <i className="fa fa-star"></i>
        </div>
      ),
    },
    {
      title: "Name",
      render: (text: any, record: any) => (
        <h2 className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-sm me-2">
            <ImageWithBasePath
              className="w-auto h-auto"
              src={record.image}
              alt="User Image"
            />
          </Link>
          <Link to="#" className="d-flex flex-column">
            {record.customer_name}
            <span className="text-default">{text.customer_no} </span>
          </Link>
        </h2>
      ),
      sorter: true,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      sorter: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: true,
    },
    {
      title: "Web Phone",
      dataIndex: "web_phone",
      key: "web_phone",
      sorter: true,
    },
    {
      title: "Extension",
      dataIndex: "extension",
      key: "extension",
      sorter: true,
    },
    {
      title: "Secrets",
      dataIndex: "secrets",
      key: "secrets",
      sorter: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <div>
          {text === "Active" && (
            <span className="badge badge-pill badge-status bg-success">
              {text}
            </span>
          )}

          {text === "Inactive" && (
            <span className="badge badge-pill badge-status bg-danger">
              {text}
            </span>
          )}
        </div>
      ),
      sorter: true,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-target="#offcanvas_edit"
              data-bs-toggle="offcanvas"
            >
              <i className="ti ti-edit text-blue" /> Edit
            </Link>

            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete"
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </Link>
          </div>
        </div>
      ),
    },
  ];
  const initialSettings = {
    endDate: new Date("2020-08-11T12:30:00.000Z"),
    ranges: {
      "Last 30 Days": [
        new Date("2020-07-12T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last 7 Days": [
        new Date("2020-08-04T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last Month": [
        new Date("2020-06-30T18:30:00.000Z"),
        new Date("2020-07-31T18:29:59.999Z"),
      ],
      "This Month": [
        new Date("2020-07-31T18:30:00.000Z"),
        new Date("2020-08-31T18:29:59.999Z"),
      ],
      Today: [
        new Date("2020-08-10T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      Yesterday: [
        new Date("2020-08-09T04:57:17.076Z"),
        new Date("2020-08-09T04:57:17.076Z"),
      ],
    },
    startDate: new Date("2020-08-04T04:57:17.076Z"), // Set "Last 7 Days" as default
    timePicker: false,
  };
  const [extension, setExtension] = useState("");

  const getExtension = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}

              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                      User<span className="count-title">123</span>
                    </h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-3 mb-sm-0">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search User"
                        />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        {/* <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-package-export me-2" />
                            Export
                          </Link>
                          <div className="dropdown-menu  dropdown-menu-end">
                            <ul>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-pdf text-danger me-1" />
                                  Export as PDF
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-xls text-green me-1" />
                                  Export as Excel{" "}
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div> */}
                        <Link
                          to="#"
                          className="btn btn-primary"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvas_add"
                        >
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add user
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Search */}
                </div>
                <div className="card-body">
                  {/* Filter */}
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-sort-ascending-2 me-2" />
                          Sort{" "}
                        </Link>
                        <div className="dropdown-menu  dropdown-menu-start">
                          <ul>
                            <li>
                              <Link to="#" className="dropdown-item">
                                <i className="ti ti-circle-chevron-right me-1" />
                                Ascending
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="dropdown-item">
                                <i className="ti ti-circle-chevron-right me-1" />
                                Descending
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="dropdown-item">
                                <i className="ti ti-circle-chevron-right me-1" />
                                Recently Viewed
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="dropdown-item">
                                <i className="ti ti-circle-chevron-right me-1" />
                                Recently Added
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar" />
                        </span>
                        <DateRangePicker initialSettings={initialSettings}>
                          <input
                            className="form-control bookingrange"
                            type="text"
                          />
                        </DateRangePicker>
                      </div>
                    </div>
                    {/* <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="btn bg-soft-purple text-purple"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-columns-3 me-2" />
                          Manage Columns
                        </Link>
                        <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                          <h4 className="mb-2 fw-semibold">
                            Want to manage datatables?
                          </h4>
                          <p className="mb-3">
                            Please drag and drop your column to reorder your
                            table and enable see option as you want.
                          </p>
                          <div className="border-top pt-3">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Name
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-name"
                                  className="check"
                                />
                                <label
                                  htmlFor="col-name"
                                  className="checktoggle"
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Phone
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-phone"
                                  className="check"
                                />
                                <label
                                  htmlFor="col-phone"
                                  className="checktoggle"
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Email
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-email"
                                  className="check"
                                />
                                <label
                                  htmlFor="col-email"
                                  className="checktoggle"
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Location
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-tag"
                                  className="check"
                                />
                                <label
                                  htmlFor="col-tag"
                                  className="checktoggle"
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Created Date
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-date"
                                  className="check"
                                />
                                <label
                                  htmlFor="col-date"
                                  className="checktoggle"
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Last Activity
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-activity"
                                  className="check"
                                />
                                <label
                                  htmlFor="col-activity"
                                  className="checktoggle"
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Status
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-status"
                                  className="check"
                                />
                                <label
                                  htmlFor="col-status"
                                  className="checktoggle"
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <p className="mb-0 d-flex align-items-center">
                                <i className="ti ti-grip-vertical me-2" />
                                Action
                              </p>
                              <div className="status-toggle">
                                <input
                                  type="checkbox"
                                  id="col-action"
                                  className="check"
                                />
                                <label
                                  htmlFor="col-action"
                                  className="checktoggle"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-sorts dropdown">
                        <Link
                          to="#"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-filter-share" />
                          Filter
                        </Link>
                        <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" />
                                Filter
                              </h4>
                            </div>
                            <div className="accordion" id="accordionExample">
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo"
                                    aria-expanded="true"
                                    aria-controls="collapseTwo"
                                  >
                                    Name
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse show"
                                  id="collapseTwo"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <div className="mb-2 icon-form">
                                      <span className="form-icon">
                                        <i className="ti ti-search" />
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Name"
                                      />
                                    </div>
                                    <ul>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            Darlee Robertson
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            Sharon Roy
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            Vaughan
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            Jessica
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            Carol Thomas
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#phone"
                                    aria-expanded="false"
                                    aria-controls="phone"
                                  >
                                    Phone
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="phone"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <ul>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            +1 875455453
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            +1 989757485
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            +1 546555455
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#email"
                                    aria-expanded="false"
                                    aria-controls="email"
                                  >
                                    Email
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="email"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <ul>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            robertson@example.com
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            sharon@example.com
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            vaughan12@example.com
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#location"
                                    aria-expanded="false"
                                    aria-controls="location"
                                  >
                                    Location
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="location"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <ul>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            Germany
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            USA
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            Canada
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#owner"
                                    aria-expanded="false"
                                    aria-controls="owner"
                                  >
                                    Created Date
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="owner"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <ul>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            25 Sep 2023, 12:12 pm
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            27 Sep 2023, 07:40 am
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            29 Sep 2023, 08:20 am
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            02 Oct 2023, 10:10 am
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input type="checkbox" />
                                            <span className="checkmarks" />
                                            17 Oct 2023, 04:25 pm
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className="collapsed"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#Status"
                                    aria-expanded="false"
                                    aria-controls="Status"
                                  >
                                    Status
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse"
                                  id="Status"
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="filter-content-list">
                                    <ul>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            Active
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="filter-checks">
                                          <label className="checkboxs">
                                            <input
                                              type="checkbox"
                                              defaultChecked
                                            />
                                            <span className="checkmarks" />
                                            Inactive
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="filter-reset-btns">
                              <div className="row">
                                <div className="col-6">
                                  <Link to="#" className="btn btn-light">
                                    Reset
                                  </Link>
                                </div>
                                <div className="col-6">
                                  <Link to="#" className="btn btn-primary">
                                    Filter
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  {/* /Filter */}
                  {/* Manage Users List */}
                  <div className="table-responsive custom-table">
                    <Table columns={columns} dataSource={data} />
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="datatable-length" />
                    </div>
                    <div className="col-md-6">
                      <div className="datatable-paginate" />
                    </div>
                  </div>
                  {/* /Manage Users List */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add User */}
      <div
        className="offcanvas " style={{ width: '1150px',right:"0", top:'0' }}
        tabIndex={-1}
        id="offcanvas_add"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add New User</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div>
              {/* Basic Info */}
              <div>
                <div className="row">
                  {/* <div className="col-md-12">
                    <div className="profile-pic-upload">
                      <div className="profile-pic">
                        <span>
                          <i className="ti ti-photo" />
                        </span>
                      </div>
                      <div className="upload-content">
                        <div className="upload-btn">
                          <input type="file" />
                          <span>
                            <i className="ti ti-file-broken" />
                            Upload File
                          </span>
                        </div>
                        <p>JPG, GIF or PNG. Max size of 800K</p>
                      </div>
                    </div>
                  </div> */}
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        {" "}
                        First Name <span className="text-danger">*</span>
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="ti-user"></i>
                        </span>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="ti-user"></i>
                        </span>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <label className="col-form-label">
                          Email <span className="text-danger">*</span>
                        </label>
                        <div className="status-toggle small-toggle-btn d-flex align-items-center">
                         
                          <input
                            type="checkbox"
                            id="user1"
                            className="check"
                            placeholder=" Enter Email"
                            defaultChecked
                          />
                          <label htmlFor="user1" className="checktoggle"  />
                        </div>
                      </div>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group ">
                      <label className="form-label">Voice Server </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="ti-server"></i>
                        </span>
                        <select
                          className="form-control"
                          name="asterisk_server_id"
                          id="asterisk_server_id"
                        >
                          <option value="8">sip2.cafmotel.com</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-label">
                        Extension <span id="errorExtension"></span>
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="ti-mobile"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          name="extension"
                          id="extension"
                          value={extension}
                          onChange={(e) => setExtension(e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() =>
                            setExtension(getExtension(1000, 9999).toString())
                          }
                        >
                          Auto Generate
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Phone Number <span className="text-danger">*</span>
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="ti-mobile"></i>
                        </span>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Password <span className="text-danger">*</span>
                      </label>
                      <div className="icon-form-end">
                        <span className="form-icon">
                          <i className="ti ti-eye-off" />
                        </span>
                        <input type="password" className="form-control" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Select Country <span className="text-danger">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group ">
                      <label className="form-label">CLI Setting</label>
                      <div className="input-group mb-3">
                        <span className="input-group-text ">
                          <i className="ti-user"></i>
                        </span>
                        <select
                          className="form-select"
                          name="cli_setting"
                          id="cli_setting"
                        >
                          <option value="0">Area Code</option>
                          <option value="1">Custom</option>
                          <option value="2">AreaCode And Randomizer</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group ">
                      <label className="form-label">Extension Type</label>
                      <div className="input-group mb-3">
                        <span className="input-group-text ">
                          <i className="ti-user"></i>
                        </span>
                        <select
                          className="form-select"
                          name="extension_type"
                          id="extension_type"
                        >
                          <option value="1">Extension</option>
                          <option value="2">Ring Group</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group ">
                      <label className="form-label">Select Packages</label>
                      <div className="input-group mb-3">
                        <span className="input-group-text ">
                          <i className="ti-user"></i>
                        </span>
                        <select
                          className="form-select"
                          name="package_id"
                          id="package_id"
                        >
                          <option value="">Please Select Package</option>

                          <option value="160">Premium (8 Remaining)</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group ">
                      <label className="form-label">Timezone</label>
                      <div className="input-group mb-3">
                        <span className="input-group-text ">
                          <i className="ti-time"></i>
                        </span>
                        <select className="form-select" name="timezone">
                          <option value="">Select Timezone</option>
                          <option value="Pacific/Midway">
                            (GMT-11:00) Midway Island, Samoa
                          </option>
                          <option value="America/Adak">
                            (GMT-10:00) Hawaii-Aleutian
                          </option>
                          <option value="Etc/GMT+10">(GMT-10:00) Hawaii</option>
                          <option value="Pacific/Marquesas">
                            (GMT-09:30) Marquesas Islands
                          </option>
                          <option value="Pacific/Gambier">
                            (GMT-09:00) Gambier Islands
                          </option>
                          <option value="America/Anchorage">
                            (GMT-09:00) Alaska
                          </option>
                          <option value="America/Ensenada">
                            (GMT-08:00) Tijuana, Baja California
                          </option>
                          <option value="Etc/GMT+8">
                            (GMT-08:00) Pitcairn Islands
                          </option>
                          <option value="America/Los_Angeles">
                            (GMT-08:00) Pacific Time (US &amp; Canada)
                          </option>
                          <option value="America/Denver">
                            (GMT-07:00) Mountain Time (US &amp; Canada)
                          </option>
                          <option value="America/Chihuahua">
                            (GMT-07:00) Chihuahua, La Paz, Mazatlan
                          </option>
                          <option value="America/Dawson_Creek">
                            (GMT-07:00) Arizona
                          </option>
                          <option value="America/Belize">
                            (GMT-06:00) Saskatchewan, Central America
                          </option>
                          <option value="America/Cancun">
                            (GMT-06:00) Guadalajara, Mexico City, Monterrey
                          </option>
                          <option value="Chile/EasterIsland">
                            (GMT-06:00) Easter Island
                          </option>
                          <option value="America/Chicago">
                            (GMT-06:00) Central Time (US &amp; Canada)
                          </option>
                          <option value="America/New_York">
                            (GMT-05:00) Eastern Time (US &amp; Canada)
                          </option>
                          <option value="America/Havana">
                            (GMT-05:00) Cuba
                          </option>
                          <option value="America/Bogota">
                            (GMT-05:00) Bogota, Lima, Quito, Rio Branco
                          </option>
                          <option value="America/Caracas">
                            (GMT-04:30) Caracas
                          </option>
                          <option value="America/Santiago">
                            (GMT-04:00) Santiago
                          </option>
                          <option value="America/La_Paz">
                            (GMT-04:00) La Paz
                          </option>
                          <option value="Atlantic/Stanley">
                            (GMT-04:00) Faukland Islands
                          </option>
                          <option value="America/Campo_Grande">
                            (GMT-04:00) Brazil
                          </option>
                          <option value="America/Goose_Bay">
                            (GMT-04:00) Atlantic Time (Goose Bay)
                          </option>
                          <option value="America/Glace_Bay">
                            (GMT-04:00) Atlantic Time (Canada)
                          </option>
                          <option value="America/St_Johns">
                            (GMT-03:30) Newfoundland
                          </option>
                          <option value="America/Araguaina">
                            (GMT-03:00) UTC-3
                          </option>
                          <option value="America/Montevideo">
                            (GMT-03:00) Montevideo
                          </option>
                          <option value="America/Miquelon">
                            (GMT-03:00) Miquelon, St. Pierre
                          </option>
                          <option value="America/Godthab">
                            (GMT-03:00) Greenland
                          </option>
                          <option value="America/Argentina/Buenos_Aires">
                            (GMT-03:00) Buenos Aires
                          </option>
                          <option value="America/Sao_Paulo">
                            (GMT-03:00) Brasilia
                          </option>
                          <option value="America/Noronha">
                            (GMT-02:00) Mid-Atlantic
                          </option>
                          <option value="Atlantic/Cape_Verde">
                            (GMT-01:00) Cape Verde Is.
                          </option>
                          <option value="Atlantic/Azores">
                            (GMT-01:00) Azores
                          </option>
                          <option value="Europe/Belfast">
                            (GMT) Greenwich Mean Time : Belfast
                          </option>
                          <option value="Europe/Dublin">
                            (GMT) Greenwich Mean Time : Dublin
                          </option>
                          <option value="Europe/Lisbon">
                            (GMT) Greenwich Mean Time : Lisbon
                          </option>
                          <option value="Europe/London">
                            (GMT) Greenwich Mean Time : London
                          </option>
                          <option value="Africa/Abidjan">
                            (GMT) Monrovia, Reykjavik
                          </option>
                          <option value="Europe/Amsterdam">
                            (GMT+01:00) Amsterdam, Berlin, Bern, Rome,
                            Stockholm, Vienna
                          </option>
                          <option value="Europe/Belgrade">
                            (GMT+01:00) Belgrade, Bratislava, Budapest,
                            Ljubljana, Prague
                          </option>
                          <option value="Europe/Brussels">
                            (GMT+01:00) Brussels, Copenhagen, Madrid, Paris
                          </option>
                          <option value="Africa/Algiers">
                            (GMT+01:00) West Central Africa
                          </option>
                          <option value="Africa/Windhoek">
                            (GMT+01:00) Windhoek
                          </option>
                          <option value="Asia/Beirut">
                            (GMT+02:00) Beirut
                          </option>
                          <option value="Africa/Cairo">
                            (GMT+02:00) Cairo
                          </option>
                          <option value="Asia/Gaza">(GMT+02:00) Gaza</option>
                          <option value="Africa/Blantyre">
                            (GMT+02:00) Harare, Pretoria
                          </option>
                          <option value="Asia/Jerusalem">
                            (GMT+02:00) Jerusalem
                          </option>
                          <option value="Europe/Minsk">
                            (GMT+02:00) Minsk
                          </option>
                          <option value="Asia/Damascus">
                            (GMT+02:00) Syria
                          </option>
                          <option value="Europe/Moscow">
                            (GMT+03:00) Moscow, St. Petersburg, Volgograd
                          </option>
                          <option value="Africa/Addis_Ababa">
                            (GMT+03:00) Nairobi
                          </option>
                          <option value="Asia/Tehran">
                            (GMT+03:30) Tehran
                          </option>
                          <option value="Asia/Dubai">
                            (GMT+04:00) Abu Dhabi, Muscat
                          </option>
                          <option value="Asia/Yerevan">
                            (GMT+04:00) Yerevan
                          </option>
                          <option value="Asia/Kabul">(GMT+04:30) Kabul</option>
                          <option value="Asia/Yekaterinburg">
                            (GMT+05:00) Ekaterinburg
                          </option>
                          <option value="Asia/Tashkent">
                            (GMT+05:00) Tashkent
                          </option>
                          <option value="Asia/Kolkata">
                            (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi
                          </option>
                          <option value="Asia/Katmandu">
                            (GMT+05:45) Kathmandu
                          </option>
                          <option value="Asia/Dhaka">
                            (GMT+06:00) Astana, Dhaka
                          </option>
                          <option value="Asia/Novosibirsk">
                            (GMT+06:00) Novosibirsk
                          </option>
                          <option value="Asia/Rangoon">
                            (GMT+06:30) Yangon (Rangoon)
                          </option>
                          <option value="Asia/Bangkok">
                            (GMT+07:00) Bangkok, Hanoi, Jakarta
                          </option>
                          <option value="Asia/Krasnoyarsk">
                            (GMT+07:00) Krasnoyarsk
                          </option>
                          <option value="Asia/Hong_Kong">
                            (GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi
                          </option>
                          <option value="Asia/Irkutsk">
                            (GMT+08:00) Irkutsk, Ulaan Bataar
                          </option>
                          <option value="Australia/Perth">
                            (GMT+08:00) Perth
                          </option>
                          <option value="Australia/Eucla">
                            (GMT+08:45) Eucla
                          </option>
                          <option value="Asia/Tokyo">
                            (GMT+09:00) Osaka, Sapporo, Tokyo
                          </option>
                          <option value="Asia/Seoul">(GMT+09:00) Seoul</option>
                          <option value="Asia/Yakutsk">
                            (GMT+09:00) Yakutsk
                          </option>
                          <option value="Australia/Adelaide">
                            (GMT+09:30) Adelaide
                          </option>
                          <option value="Australia/Darwin">
                            (GMT+09:30) Darwin
                          </option>
                          <option value="Australia/Brisbane">
                            (GMT+10:00) Brisbane
                          </option>
                          <option value="Australia/Hobart">
                            (GMT+10:00) Hobart
                          </option>
                          <option value="Asia/Vladivostok">
                            (GMT+10:00) Vladivostok
                          </option>
                          <option value="Australia/Lord_Howe">
                            (GMT+10:30) Lord Howe Island
                          </option>
                          <option value="Etc/GMT-11">
                            (GMT+11:00) Solomon Is., New Caledonia
                          </option>
                          <option value="Asia/Magadan">
                            (GMT+11:00) Magadan
                          </option>
                          <option value="Pacific/Norfolk">
                            (GMT+11:30) Norfolk Island
                          </option>
                          <option value="Asia/Anadyr">
                            (GMT+12:00) Anadyr, Kamchatka
                          </option>
                          <option value="Pacific/Auckland">
                            (GMT+12:00) Auckland, Wellington
                          </option>
                          <option value="Etc/GMT-12">
                            (GMT+12:00) Fiji, Kamchatka, Marshall Is.
                          </option>
                          <option value="Pacific/Chatham">
                            (GMT+12:45) Chatham Islands
                          </option>
                          <option value="Pacific/Tongatapu">
                            (GMT+13:00) Nuku'alofa
                          </option>
                          <option value="Pacific/Kiritimati">
                            (GMT+14:00) Kiritimati
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">Group</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">Follow Me</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">Call Forward</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">Enable 2FA</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Allow Mobile App Login
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-label">
                        Voice Mail Pin <span id="errorExtension"></span>
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="ti-mobile"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          name="extension"
                          id="extension"
                          value={extension}
                          onChange={(e) => setExtension(e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() =>
                            setExtension(getExtension(1000, 9999).toString())
                          }
                        >
                          Auto Generate
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Send Voicemail to email
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">Twinning</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">IP Filtering</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="radio-wrap">
                      <label className="col-form-label">Status</label>
                      <div className="d-flex align-items-center">
                        <div className="me-2">
                          <input
                            type="radio"
                            className="status-radio"
                            id="active1"
                            name="status"
                            defaultChecked
                          />
                          <label htmlFor="active1">Active</label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            className="status-radio"
                            id="inactive1"
                            name="status"
                          />
                          <label htmlFor="inactive1">Inactive</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="checkbox-wrap">
                      <label className="col-form-label" style={{ paddingBottom:'12px' }} >
                        Forward Incoming SMS To
                      </label>
                      <div className="d-flex align-items-center ">
                        <div className="me-2 ">
                          <input
                            type="checkbox"
                            className="status-checkbox me-2 mb-1"
                            id="active1"
                            name="status"
                          />
                          <label htmlFor="active1">Email</label>
                        </div>
                        <div>
                          <input
                            type="checkbox"
                            className="status-checkbox me-2"
                            id="inactive1"
                            name="status"
                          />
                          <label htmlFor="inactive1">Sms</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Basic Info */}
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <Link
                to="#"
                className="btn btn-light me-2"
                data-bs-dismiss="offcanvas"
              >
                Cancel
              </Link>

              <button type="button" className="btn btn-primary">
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Add User */}
      {/* Edit User */}
      <div
        className="offcanvas" style={{ width: '1150px',right:"0", top:'0' }}
        tabIndex={-1}
        id="offcanvas_edit"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Edit User</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div>
              {/* Basic Info */}
              <div>
                <div className="row">
                <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        {" "}
                        First Name <span className="text-danger">*</span>
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="ti-user"></i>
                        </span>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="ti-user"></i>
                        </span>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <label className="col-form-label">
                          Email <span className="text-danger">*</span>
                        </label>
                        <div className="status-toggle small-toggle-btn d-flex align-items-center">
                          <span className="me-2 label-text">Email Opt Out</span>
                          <input
                            type="checkbox"
                            id="user1"
                            className="check"
                            defaultChecked
                          />
                          <label htmlFor="user1" className="checktoggle" />
                        </div>
                      </div>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group ">
                      <label className="form-label">Voice Server </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="ti-server"></i>
                        </span>
                        <select
                          className="form-control"
                          name="asterisk_server_id"
                          id="asterisk_server_id"
                        >
                          <option value="8">sip2.cafmotel.com</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-label">
                        Extension <span id="errorExtension"></span>
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="ti-mobile"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          name="extension"
                          id="extension"
                          value={extension}
                          onChange={(e) => setExtension(e.target.value)}
                        />
                     
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Phone Number <span className="text-danger">*</span>
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="ti-mobile"></i>
                        </span>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Password <span className="text-danger">*</span>
                      </label>
                      <div className="icon-form-end">
                        <span className="form-icon">
                          <i className="ti ti-eye-off" />
                        </span>
                        <input type="password" className="form-control" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Select Country <span className="text-danger">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group ">
                      <label className="form-label">CLI Setting</label>
                      <div className="input-group mb-3">
                        <span className="input-group-text ">
                          <i className="ti-user"></i>
                        </span>
                        <select
                          className="form-select"
                          name="cli_setting"
                          id="cli_setting"
                        >
                          <option value="0">Area Code</option>
                          <option value="1">Custom</option>
                          <option value="2">AreaCode And Randomizer</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group ">
                      <label className="form-label">Extension Type</label>
                      <div className="input-group mb-3">
                        <span className="input-group-text ">
                          <i className="ti-user"></i>
                        </span>
                        <select
                          className="form-select"
                          name="extension_type"
                          id="extension_type"
                        >
                          <option value="1">Extension</option>
                          <option value="2">Ring Group</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group ">
                      <label className="form-label">Select Packages</label>
                      <div className="input-group mb-3">
                        <span className="input-group-text ">
                          <i className="ti-user"></i>
                        </span>
                        <select
                          className="form-select"
                          name="package_id"
                          id="package_id"
                        >
                          <option value="">Please Select Package</option>

                          <option value="160">Premium (8 Remaining)</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group ">
                      <label className="form-label">Timezone</label>
                      <div className="input-group mb-3">
                        <span className="input-group-text ">
                          <i className="ti-time"></i>
                        </span>
                        <select className="form-select" name="timezone">
                          <option value="">Select Timezone</option>
                          <option value="Pacific/Midway">
                            (GMT-11:00) Midway Island, Samoa
                          </option>
                          <option value="America/Adak">
                            (GMT-10:00) Hawaii-Aleutian
                          </option>
                          <option value="Etc/GMT+10">(GMT-10:00) Hawaii</option>
                          <option value="Pacific/Marquesas">
                            (GMT-09:30) Marquesas Islands
                          </option>
                          <option value="Pacific/Gambier">
                            (GMT-09:00) Gambier Islands
                          </option>
                          <option value="America/Anchorage">
                            (GMT-09:00) Alaska
                          </option>
                          <option value="America/Ensenada">
                            (GMT-08:00) Tijuana, Baja California
                          </option>
                          <option value="Etc/GMT+8">
                            (GMT-08:00) Pitcairn Islands
                          </option>
                          <option value="America/Los_Angeles">
                            (GMT-08:00) Pacific Time (US &amp; Canada)
                          </option>
                          <option value="America/Denver">
                            (GMT-07:00) Mountain Time (US &amp; Canada)
                          </option>
                          <option value="America/Chihuahua">
                            (GMT-07:00) Chihuahua, La Paz, Mazatlan
                          </option>
                          <option value="America/Dawson_Creek">
                            (GMT-07:00) Arizona
                          </option>
                          <option value="America/Belize">
                            (GMT-06:00) Saskatchewan, Central America
                          </option>
                          <option value="America/Cancun">
                            (GMT-06:00) Guadalajara, Mexico City, Monterrey
                          </option>
                          <option value="Chile/EasterIsland">
                            (GMT-06:00) Easter Island
                          </option>
                          <option value="America/Chicago">
                            (GMT-06:00) Central Time (US &amp; Canada)
                          </option>
                          <option value="America/New_York">
                            (GMT-05:00) Eastern Time (US &amp; Canada)
                          </option>
                          <option value="America/Havana">
                            (GMT-05:00) Cuba
                          </option>
                          <option value="America/Bogota">
                            (GMT-05:00) Bogota, Lima, Quito, Rio Branco
                          </option>
                          <option value="America/Caracas">
                            (GMT-04:30) Caracas
                          </option>
                          <option value="America/Santiago">
                            (GMT-04:00) Santiago
                          </option>
                          <option value="America/La_Paz">
                            (GMT-04:00) La Paz
                          </option>
                          <option value="Atlantic/Stanley">
                            (GMT-04:00) Faukland Islands
                          </option>
                          <option value="America/Campo_Grande">
                            (GMT-04:00) Brazil
                          </option>
                          <option value="America/Goose_Bay">
                            (GMT-04:00) Atlantic Time (Goose Bay)
                          </option>
                          <option value="America/Glace_Bay">
                            (GMT-04:00) Atlantic Time (Canada)
                          </option>
                          <option value="America/St_Johns">
                            (GMT-03:30) Newfoundland
                          </option>
                          <option value="America/Araguaina">
                            (GMT-03:00) UTC-3
                          </option>
                          <option value="America/Montevideo">
                            (GMT-03:00) Montevideo
                          </option>
                          <option value="America/Miquelon">
                            (GMT-03:00) Miquelon, St. Pierre
                          </option>
                          <option value="America/Godthab">
                            (GMT-03:00) Greenland
                          </option>
                          <option value="America/Argentina/Buenos_Aires">
                            (GMT-03:00) Buenos Aires
                          </option>
                          <option value="America/Sao_Paulo">
                            (GMT-03:00) Brasilia
                          </option>
                          <option value="America/Noronha">
                            (GMT-02:00) Mid-Atlantic
                          </option>
                          <option value="Atlantic/Cape_Verde">
                            (GMT-01:00) Cape Verde Is.
                          </option>
                          <option value="Atlantic/Azores">
                            (GMT-01:00) Azores
                          </option>
                          <option value="Europe/Belfast">
                            (GMT) Greenwich Mean Time : Belfast
                          </option>
                          <option value="Europe/Dublin">
                            (GMT) Greenwich Mean Time : Dublin
                          </option>
                          <option value="Europe/Lisbon">
                            (GMT) Greenwich Mean Time : Lisbon
                          </option>
                          <option value="Europe/London">
                            (GMT) Greenwich Mean Time : London
                          </option>
                          <option value="Africa/Abidjan">
                            (GMT) Monrovia, Reykjavik
                          </option>
                          <option value="Europe/Amsterdam">
                            (GMT+01:00) Amsterdam, Berlin, Bern, Rome,
                            Stockholm, Vienna
                          </option>
                          <option value="Europe/Belgrade">
                            (GMT+01:00) Belgrade, Bratislava, Budapest,
                            Ljubljana, Prague
                          </option>
                          <option value="Europe/Brussels">
                            (GMT+01:00) Brussels, Copenhagen, Madrid, Paris
                          </option>
                          <option value="Africa/Algiers">
                            (GMT+01:00) West Central Africa
                          </option>
                          <option value="Africa/Windhoek">
                            (GMT+01:00) Windhoek
                          </option>
                          <option value="Asia/Beirut">
                            (GMT+02:00) Beirut
                          </option>
                          <option value="Africa/Cairo">
                            (GMT+02:00) Cairo
                          </option>
                          <option value="Asia/Gaza">(GMT+02:00) Gaza</option>
                          <option value="Africa/Blantyre">
                            (GMT+02:00) Harare, Pretoria
                          </option>
                          <option value="Asia/Jerusalem">
                            (GMT+02:00) Jerusalem
                          </option>
                          <option value="Europe/Minsk">
                            (GMT+02:00) Minsk
                          </option>
                          <option value="Asia/Damascus">
                            (GMT+02:00) Syria
                          </option>
                          <option value="Europe/Moscow">
                            (GMT+03:00) Moscow, St. Petersburg, Volgograd
                          </option>
                          <option value="Africa/Addis_Ababa">
                            (GMT+03:00) Nairobi
                          </option>
                          <option value="Asia/Tehran">
                            (GMT+03:30) Tehran
                          </option>
                          <option value="Asia/Dubai">
                            (GMT+04:00) Abu Dhabi, Muscat
                          </option>
                          <option value="Asia/Yerevan">
                            (GMT+04:00) Yerevan
                          </option>
                          <option value="Asia/Kabul">(GMT+04:30) Kabul</option>
                          <option value="Asia/Yekaterinburg">
                            (GMT+05:00) Ekaterinburg
                          </option>
                          <option value="Asia/Tashkent">
                            (GMT+05:00) Tashkent
                          </option>
                          <option value="Asia/Kolkata">
                            (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi
                          </option>
                          <option value="Asia/Katmandu">
                            (GMT+05:45) Kathmandu
                          </option>
                          <option value="Asia/Dhaka">
                            (GMT+06:00) Astana, Dhaka
                          </option>
                          <option value="Asia/Novosibirsk">
                            (GMT+06:00) Novosibirsk
                          </option>
                          <option value="Asia/Rangoon">
                            (GMT+06:30) Yangon (Rangoon)
                          </option>
                          <option value="Asia/Bangkok">
                            (GMT+07:00) Bangkok, Hanoi, Jakarta
                          </option>
                          <option value="Asia/Krasnoyarsk">
                            (GMT+07:00) Krasnoyarsk
                          </option>
                          <option value="Asia/Hong_Kong">
                            (GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi
                          </option>
                          <option value="Asia/Irkutsk">
                            (GMT+08:00) Irkutsk, Ulaan Bataar
                          </option>
                          <option value="Australia/Perth">
                            (GMT+08:00) Perth
                          </option>
                          <option value="Australia/Eucla">
                            (GMT+08:45) Eucla
                          </option>
                          <option value="Asia/Tokyo">
                            (GMT+09:00) Osaka, Sapporo, Tokyo
                          </option>
                          <option value="Asia/Seoul">(GMT+09:00) Seoul</option>
                          <option value="Asia/Yakutsk">
                            (GMT+09:00) Yakutsk
                          </option>
                          <option value="Australia/Adelaide">
                            (GMT+09:30) Adelaide
                          </option>
                          <option value="Australia/Darwin">
                            (GMT+09:30) Darwin
                          </option>
                          <option value="Australia/Brisbane">
                            (GMT+10:00) Brisbane
                          </option>
                          <option value="Australia/Hobart">
                            (GMT+10:00) Hobart
                          </option>
                          <option value="Asia/Vladivostok">
                            (GMT+10:00) Vladivostok
                          </option>
                          <option value="Australia/Lord_Howe">
                            (GMT+10:30) Lord Howe Island
                          </option>
                          <option value="Etc/GMT-11">
                            (GMT+11:00) Solomon Is., New Caledonia
                          </option>
                          <option value="Asia/Magadan">
                            (GMT+11:00) Magadan
                          </option>
                          <option value="Pacific/Norfolk">
                            (GMT+11:30) Norfolk Island
                          </option>
                          <option value="Asia/Anadyr">
                            (GMT+12:00) Anadyr, Kamchatka
                          </option>
                          <option value="Pacific/Auckland">
                            (GMT+12:00) Auckland, Wellington
                          </option>
                          <option value="Etc/GMT-12">
                            (GMT+12:00) Fiji, Kamchatka, Marshall Is.
                          </option>
                          <option value="Pacific/Chatham">
                            (GMT+12:45) Chatham Islands
                          </option>
                          <option value="Pacific/Tongatapu">
                            (GMT+13:00) Nuku'alofa
                          </option>
                          <option value="Pacific/Kiritimati">
                            (GMT+14:00) Kiritimati
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">Group</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">Follow Me</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">Call Forward</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">Enable 2FA</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Allow Mobile App Login
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-label">
                        Voice Mail Pin <span id="errorExtension"></span>
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          <i className="ti-mobile"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          name="extension"
                          id="extension"
                          value={extension}
                          onChange={(e) => setExtension(e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() =>
                            setExtension(getExtension(1000, 9999).toString())
                          }
                        >
                          Auto Generate
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Send Voicemail to email
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">Twinning</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="col-form-label">IP Filtering</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={options3}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="radio-wrap">
                      <label className="col-form-label">Status</label>
                      <div className="d-flex align-items-center">
                        <div className="me-2">
                          <input
                            type="radio"
                            className="status-radio"
                            id="active1"
                            name="status"
                            defaultChecked
                          />
                          <label htmlFor="active1">Active</label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            className="status-radio"
                            id="inactive1"
                            name="status"
                          />
                          <label htmlFor="inactive1">Inactive</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="checkbox-wrap">
                      <label className="col-form-label" style={{ paddingBottom:'12px' }} >
                        Forward Incoming SMS To
                      </label>
                      <div className="d-flex align-items-center ">
                        <div className="me-2 ">
                          <input
                            type="checkbox"
                            className="status-checkbox me-2 mb-1"
                            id="active1"
                            name="status"
                          />
                          <label htmlFor="active1">Email</label>
                        </div>
                        <div>
                          <input
                            type="checkbox"
                            className="status-checkbox me-2"
                            id="inactive1"
                            name="status"
                          />
                          <label htmlFor="inactive1">Sms</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Basic Info */}
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <Link
                to="#"
                className="btn btn-light me-2"
                data-bs-dismiss="offcanvas"
              >
                Cancel
              </Link>
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-primary me-2"
              >
               Reset
              </button>
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-secondary me-2"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Edit User */}
      {/* Delete User */}
      <div className="modal fade" id="delete" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove users?</h4>
                <p className="mb-0">Are you sure you want to remove it</p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to="#" className="btn btn-danger">
                    Yes, Delete it
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete User */}
    </>
  );
};

export default Manageusers;
